import { render } from "./CustomerOrderListView.vue?vue&type=template&id=81d2650c&scoped=true"
import script from "./CustomerOrderListView.vue?vue&type=script&lang=js"
export * from "./CustomerOrderListView.vue?vue&type=script&lang=js"

import "./CustomerOrderListView.vue?vue&type=style&index=0&id=81d2650c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d2650c"]])

export default __exports__